// extracted by mini-css-extract-plugin
export var column = "Calendar-module--column--J2Jmi";
export var heading = "Calendar-module--heading--vM5Rw";
export var monthTile = "Calendar-module--monthTile--pGqFn";
export var emptyTile = "Calendar-module--emptyTile--Elh7y";